import React from 'react';
import SliderS from 'react-slick';
import clsx from 'clsx';

import { ReactComponent as Arrow } from 'assets/images/icons/newGalleryArrow.svg';

import 'slick-carousel/slick/slick.css';
import style from './horizontalSlider.module.scss';

export const HorizontalSlider = React.forwardRef(
  (
    {
      children,
      className,
      customArrowsClassName,
      toggleActiveClass,
      ...settings
    },
    ref,
  ) => {
    const defaultSettings = {
      verticalSwiping: false,
      infinite: true,
      slidesToScroll: 1,
      adaptiveHeight: false,
      autoplay: false,
      autoplaySpeed: 4000,
      vertical: false,
      centerPadding: 0,
      nextArrow: (
        <NextArrow
          customArrowsClassName={customArrowsClassName}
          toggleActiveClass={toggleActiveClass}
        />
      ),
      prevArrow: (
        <PrevArrow
          customArrowsClassName={customArrowsClassName}
          toggleActiveClass={toggleActiveClass}
        />
      ),
    };

    if (children.length === 1) return null;

    if (children.length <= settings.slidesToShow)
      return <div className={style.noSlides}>{children}</div>;

    return (
      <SliderS
        ref={ref}
        {...defaultSettings}
        {...settings}
        className={clsx(style.slider, className)}
      >
        {children}
      </SliderS>
    );
  },
);

export function NextArrow({
  onClick,
  customArrowsClassName,
  toggleActiveClass,
}) {
  return (
    <div
      onClick={onClick}
      onTouchStart={toggleActiveClass}
      onTouchEnd={toggleActiveClass}
      className={clsx(style.arrowNext, customArrowsClassName)}
    >
      <Arrow />
    </div>
  );
}
export function PrevArrow({
  onClick,
  customArrowsClassName,
  toggleActiveClass,
}) {
  return (
    <div
      onClick={onClick}
      onTouchStart={toggleActiveClass}
      onTouchEnd={toggleActiveClass}
      className={clsx(style.arrowPrev, customArrowsClassName)}
    >
      <Arrow />
    </div>
  );
}
